import styled, { keyframes } from "styled-components";
import get from "lodash.get";

export const StyledButton = styled.button`
  border-radius: 6px;
  background-color: ${({ theme }) => get(theme, "primary.main")} !important;
  padding: 9px 25px;
  outline: none;
  border: none;
  color: ${({ theme }) => get(theme, "text.dark")};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: -0.02em;
  box-shadow: none !important;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-decoration: none !important;
  position: relative;
  transition: all ease 0.2s;
  overflow: hidden;
  svg {
    width: 25px;
    height: 25px;
    path {
      transition: all 0.1s ease-in-out;
      fill: ${({ theme }) => get(theme, "text.dark")};
    }
  }
  &:hover {
    /* background: ${({ theme }) => get(theme, "info.light")} !important; */
  }

  &::before {
    content: " ";
    display: block;
    width: 200px;
    height: 90px;
    background: ${({ theme }) => get(theme, "form.dark")};
    position: absolute;
    top: -10px;
    left: -200px;
    transform: rotate(-45deg);
    transition: all 0.2s ease-in-out;
  }
  &:hover::before {
    left: 300% !important;
  }

  &:disabled {
    background-color: #f5f5f5 !important;
    color: #999;
  }
`;

/* export const CancelButton = styled.button`
  border-radius: 6px;
  background: ${({ theme }) => (theme.white.main)} !important;
  padding: 8.5px 24px;
  outline: none;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: -0.02em;
  border: 1px solid rgba(166, 141, 252, 0.39);
  margin-right: 1rem;
  transition: all 0.2s ease-in-out;
  position: relative;
  &:hover {
  }
  &:disabled {
    color: transparent !important;
  }
`; */

export const CancelButton = styled.button`
  border-radius: 6px;
  background: transparent;
  padding: 9px 24px;
  outline: none;
  color: ${({ theme }) => get(theme, "secondary.dark")};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: -0.02em;
  border: none;
  margin-right: 1rem;
  transition: all 0.2s ease-in-out;
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover {
    background: ${({ theme }) => get(theme, "background.hoverPrimary")} !important;
  }
`;

export const DeleteButton = styled.button`
  border-radius: 6px;
  background: ${({ theme }) => get(theme, "background.main")} !important;
  padding: 9.7px 12px;
  //box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  outline: none;
  color: ${({ theme }) => get(theme, "error.main")} !important;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
  letter-spacing: -0.02em;
  //border: 1px solid ${({ theme }) => theme.black.main};
  box-sizing: border-box;
  //filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.03));
  border: none;
  &:hover {
    background: ${({ theme }) => get(theme, "error.light")} !important;
  }
`;

export const CustomLink = styled.span<any>`
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    cursor: ${({ check }) => (check ? "pointer" : "")};
    color: ${({ check, theme }) =>
      check ? get(theme, "info.light") : get(theme, "info.dark")} !important;
    text-decoration: ${({ check }) => (check ? "underline" : "none")};
  }
`;

export const CustomIconStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  border-radius: 5px;
  transition: 0.2s ease all;
  cursor: pointer;
  svg {
    path {
      fill: ${({ theme }) => get(theme, "text.primary")};
      transition: 0.2s ease all;
    }
  }
  &:hover,
  &.active {
    /* background-color: ${({ theme }) => get(theme, "primary.light")}; */
    svg {
      path {
        fill: ${({ theme }) => get(theme, "primary.main")};
      }
    }
  }
`;

export const CustomIconWithoutBg = styled.div`
  padding: 3px;
  transition: 0.2s ease all;
  cursor: pointer;
  svg {
    path {
      fill: ${({ theme }) => get(theme, "secondary.dark")};
      transition: 0.2s ease all;
    }
  }
  &:hover,
  &.active {
    svg {
      path {
        fill: ${({ theme }) => get(theme, "primary.main")};
      }
    }
  }
`;
